import dayjs, { Dayjs } from "dayjs";

const checkDate = ({ min, max, value, isStart }: { min?: Dayjs, max?: Dayjs; value?: Dayjs; isStart: boolean }) => {
    const localeDate = dayjs(value)
    const localeMin = dayjs(min)
    const localeMax = dayjs(max)
    if (!(!min || (!!min && localeDate.isAfter(localeMin)))) return isStart ? `La fecha de inicio no puede ser menor a la fecha de actual` : `La fecha de fin no puede ser menor a la fecha de inicio`
    if (!(!max || (!!max && localeDate.isBefore(localeMax)))) return `La fecha de inicio no puede ser mayor a la fecha de fin`
    return ''
}

export { checkDate }